import React, { useState } from 'react';
import styled from 'styled-components';
import Text from 'components/Text';
import { BlueButton } from 'components/Button';
import { isPasswordValid, newPasswordsMatch } from 'utils/validate';
import { PASSWORD_MIN_LENGTH } from 'utils/appConstants';

const Form = styled.form`
  max-width: 300px;
  width: 100%;
  text-align: left;
  margin: 0.5em auto;
`;

const TextInput = styled.input`
  width: 100%;
  height: 30px;
  padding: 2px 8px;
  font-size: 16px;
  border-radius: 2px;
  border: ${({ border }) => border || '1px solid #E5E7EB'};
  outline: none;

  ::placeholder {
    color: #4a4a4a;
    opacity: 0.5;
  }
`;

const ButtonContainer = styled.div`
  margin: 1.5em 0;
  text-align: center;
`;

const ErrorMessage = styled(Text)`
  font-size: 12px;
  line-height: 16px;
  color: #ea6e6d;
  padding: 1em 0;
  white-space: pre-wrap;
`;
const SetNewPasswordForm = ({ isError, onSubmit }) => {
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [formErrorMessage, setFormErrorMessage] = useState(null);

  const handleInputChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (name === 'password') setPassword(value);
    else if (name === 'passwordConfirmation') setPasswordConfirmation(value);
  };

  const onSub = event => {
    event.preventDefault();

    if (validatePayload()) {
      onSubmit(password);
    }
  };

  const validatePayload = () => {
    let isValid = true;
    let errorMessages = [];

    if (!isPasswordValid(password)) {
      isValid = false;
      errorMessages = [
        ...errorMessages,
        'Invalid password. Please check the requirements and try again.'
      ];
    }
    if (!newPasswordsMatch(password, passwordConfirmation)) {
      isValid = false;
      errorMessages = [...errorMessages, 'Passwords must match.'];
    }

    const formErrorMessages = errorMessages.length
      ? errorMessages.join('\n')
      : null;
    setFormErrorMessage(formErrorMessages);
    return isValid;
  };

  return (
    <Form onSubmit={onSub}>
      <Text fontSize="14px" margin="4px 0px">
        New Password
      </Text>
      <Text fontSize="12px" margin="4px 0px">
        • Must be longer than {PASSWORD_MIN_LENGTH} characters
      </Text>
      <Text fontSize="12px" margin="4px 0px">
        • Must include at least 1 number and 1 special character
      </Text>
      <TextInput
        name="password"
        type="password"
        required
        onChange={handleInputChange}
      />
      <Text fontSize="14px" margin="24px 0px 4px">
        Confirm Password
      </Text>
      <TextInput
        name="passwordConfirmation"
        type="password"
        required
        onChange={handleInputChange}
      />

      {formErrorMessage ? (
        <ErrorMessage>{formErrorMessage}</ErrorMessage>
      ) : null}

      <ButtonContainer>
        <BlueButton type="submit" disabled={isError}>
          Set Password
        </BlueButton>
      </ButtonContainer>
    </Form>
  );
};

export default SetNewPasswordForm;
